import { tableOperations } from '@ardoq/table';
import { RESULTS_PER_PAGE } from '../consts';

type GremlinTableSizeProps = {
  autoHeight: boolean;
  height: string | undefined;
};

export const getGremlinTableSizeProps = (
  rowCount: number
): GremlinTableSizeProps =>
  rowCount > 0
    ? { autoHeight: true, height: undefined }
    : {
        autoHeight: false,
        height: `${tableOperations.getDynamicTableHeight(0, RESULTS_PER_PAGE)}px`,
      };
